// Lista de países para captura de leads en registro / edición de hoteles.
// Prioriza Latinoamérica (mercado principal del PMS) seguido del resto.
// Se usa el nombre como valor para mantenerlo legible en el dashboard admin.
// `dial` es el código de marcación internacional; se usa para derivar el
// prefijo del teléfono del encargado (que además alimenta al Asistente
// Sego IA vía WhatsApp, el cual exige el número en formato internacional).

const COUNTRIES = [
  { name: 'Argentina', dial: '+54' },
  { name: 'Bolivia', dial: '+591' },
  { name: 'Brasil', dial: '+55' },
  { name: 'Chile', dial: '+56' },
  { name: 'Colombia', dial: '+57' },
  { name: 'Costa Rica', dial: '+506' },
  { name: 'Cuba', dial: '+53' },
  { name: 'Ecuador', dial: '+593' },
  { name: 'El Salvador', dial: '+503' },
  { name: 'España', dial: '+34' },
  { name: 'Estados Unidos', dial: '+1' },
  { name: 'Guatemala', dial: '+502' },
  { name: 'Honduras', dial: '+504' },
  { name: 'México', dial: '+52' },
  { name: 'Nicaragua', dial: '+505' },
  { name: 'Panamá', dial: '+507' },
  { name: 'Paraguay', dial: '+595' },
  { name: 'Perú', dial: '+51' },
  { name: 'Puerto Rico', dial: '+1' },
  { name: 'República Dominicana', dial: '+1' },
  { name: 'Uruguay', dial: '+598' },
  { name: 'Venezuela', dial: '+58' },
  { name: 'Otro', dial: '' }
];

// Nombres de país para los <select>.
export const getCountries = () => COUNTRIES.map((c) => c.name);

// Código de marcación (ej. '+58') a partir del nombre del país.
// Devuelve '' si no se encuentra o es 'Otro'.
export const getCountryDialCode = (countryName) => {
  if (!countryName) return '';
  const match = COUNTRIES.find((c) => c.name === countryName);
  return match ? match.dial : '';
};

// Combina el prefijo del país con el número local en formato internacional
// (ej. dial '+58' + '0414 123 45 67' -> '+584141234567'). Si no hay prefijo
// (país 'Otro' o sin seleccionar) devuelve el número tal cual lo escribió el
// usuario, respetando un '+' inicial si lo incluyó.
export const buildInternationalPhone = (countryName, localNumber) => {
  const raw = (localNumber || '').toString().trim();
  if (!raw) return '';
  const dial = getCountryDialCode(countryName);
  if (!dial) return raw; // 'Otro' o sin país: se respeta lo escrito
  // Solo dígitos, sin el 0 troncal inicial que se omite en formato internacional.
  const digits = raw.replace(/\D/g, '').replace(/^0+/, '');
  return `${dial}${digits}`;
};

export default getCountries;
